<h1 class="pb-2">User Profile</h1>

<form (ngSubmit)="saveProfile()">
  <app-cards-basic title="Personal Information">
    <div class="row">
      <div class="col">
        <mat-form-field class="w-100">
          <mat-label>First Name</mat-label>
          <input matInput
                 placeholder="First Name"
                 [(ngModel)]="userProfile.first_name"
                 name="firstName">
        </mat-form-field>
      </div>
      <div class="col">
        <mat-form-field class="w-100">
          <mat-label>Last Name</mat-label>
          <input matInput
                 placeholder="Last Name"
                 [(ngModel)]="userProfile.last_name"
                 name="lastName">
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <mat-form-field class="w-100">
          <mat-label>E-Mail</mat-label>
          <input matInput
                 placeholder="E-Mail"
                 [(ngModel)]="profile.email"
                 name="email"
                 required>
        </mat-form-field>
      </div>
      <div class="col">
        <mat-form-field class="w-100">
          <mat-label>Mobile Phone Number</mat-label>
          <input matInput
                 placeholder="+41791234567"
                 [(ngModel)]="profile.phone_number"
                 name="phoneNumber">
        </mat-form-field>
      </div>
    </div>
  </app-cards-basic>

  <!-- Weitere Abschnitte wie Language und Subscription -->
  <app-cards-basic title="Language">
    <mat-radio-group
      [(ngModel)]="userProfile.language"
      name="language"
      [ngModelOptions]="{standalone: true}">
      @for (lang of availableLanguages; track lang) {
        <mat-radio-button [value]="lang.value">
          {{ lang.label }}
        </mat-radio-button>
      }
    </mat-radio-group>
  </app-cards-basic>

  <app-cards-basic>
    @if(currentLanguage === 'en'){
      <h3 class="pb-2">Subscribe to monthly reports</h3>
      <p class="pb-2">Please select the products for which you would like to receive the monthly report by email.</p>
    } @else {
      <h3 class="pb-2">Monatsberichte abonnieren</h3>
      <p class="pb-2">Bitte wählen Sie die Produkte aus, für die Sie den monatlichen Bericht per E-Mail erhalten möchten.</p>
    }
    @for (product of productData; track product) {
      @if(product.categories.length > 0){
        <div class="row">
          <mat-checkbox
            [checked]="userProfile.product_subscriptions?.includes(product.id)"
            (change)="onProductCheckboxChange($event, product.id)">
            {{ product.translations[currentLanguage].title }}
          </mat-checkbox>
        </div>
      }
    }
  </app-cards-basic>


  <app-cards-basic>
    <button mat-flat-button color="primary" type="submit" class="bp-button">
      Save Profile
    </button>
    <button mat-flat-button color="primary" class="bp-button" style="margin-left: 6px" (click)="logout()">
      Logout
    </button>
  </app-cards-basic>
</form>
